export default __webpack_public_path__ + "static/media/third-slide-image.bbf7ead6.png";